import { PefData } from '@sportello-balneari/pef-editor';

export const MOCK_START_YEAR = 2025;
export const MOCK_END_YEAR = 2034;

const FCF = 'flussoDiCassaPrevisionale';

const dscrByYear: Record<number, number> = {
  2025: 1.18,
  2026: 1.32,
  2027: 1.45,
  2028: 1.58,
  2029: 1.71,
  2030: 1.82,
  2031: 1.9,
  2032: 1.95,
  2033: 1.97,
  2034: 2.01,
};

const llcrByYear: Record<number, number> = {
  2025: 1.35,
  2026: 1.42,
  2027: 1.51,
  2028: 1.6,
  2029: 1.68,
  2030: 1.74,
  2031: 1.79,
  2032: 1.83,
  2033: 1.86,
  2034: 1.89,
};

const debitoResiduoByYear: Record<number, number> = {
  2025: 800_000,
  2026: 720_000,
  2027: 640_000,
  2028: 560_000,
  2029: 475_000,
  2030: 385_000,
  2031: 290_000,
  2032: 195_000,
  2033: 95_000,
  2034: 0,
};

function spread(
  map: Record<number, number>,
  key: string,
): Record<string, number> {
  return Object.fromEntries(
    Object.entries(map).map(([year, value]) => [`${key}.${year}`, value]),
  );
}

export const MOCK_PEF_DATA: PefData = {
  [`${FCF}.vanProgetto.param`]: 452_000,
  [`${FCF}.tirProgetto.param`]: 0.082,
  [`${FCF}.vanAzionista.param`]: 214_000,
  [`${FCF}.tirAzionista.param`]: 0.125,
  ...spread(dscrByYear, `${FCF}.dscr`),
  ...spread(llcrByYear, `${FCF}.llcr`),
  ...spread(debitoResiduoByYear, `${FCF}.debitoResiduo`),
};
